export const PURCHASES_ID_REQUIRED = 'PURCHASES_ID_REQUIRED';
export const PURCHASES_ID_INVALID = 'PURCHASES_ID_INVALID';
export const PURCHASES_ID_OUT_OF_STATE_CAP_EXCEEDED = 'PURCHASES_ID_OUT_OF_STATE_CAP_EXCEEDED';
export const PURCHASES_LIMITS_EXCEEDED = 'PURCHASES_LIMITS_EXCEEDED';
export const PURCHASES_PIECES_MUST_BE_INTEGER = 'PURCHASES_PIECES_MUST_BE_INTEGER';
export const PURCHASES_DRAFT_NOT_FOUND = 'PURCHASES_DRAFT_NOT_FOUND';
export const PURCHASES_DRAFT_ALREADY_ACTIVE = 'PURCHASES_DRAFT_ALREADY_ACTIVE';
export const PURCHASES_LINES_NOT_FOUND = 'PURCHASES_LINES_NOT_FOUND';
export const PURCHASES_MATERIAL_NOT_FOUND = 'PURCHASES_MATERIAL_NOT_FOUND';
export const PURCHASES_PRESENTATION_MISMATCH = 'PURCHASES_PRESENTATION_MISMATCH';
export const PURCHASES_HELD_LOCKED = 'PURCHASES_HELD_LOCKED';
export const PURCHASES_HELD_LOCK_EXPIRED = 'PURCHASES_HELD_LOCK_EXPIRED';
export const PURCHASES_COMMIT_REQUIRES_CASH_SESSION = 'PURCHASES_COMMIT_REQUIRES_CASH_SESSION';
export const PURCHASES_COMMIT_AMBIGUOUS_CASH_SESSION = 'PURCHASES_COMMIT_AMBIGUOUS_CASH_SESSION';
export const PURCHASES_COMMIT_INVALID_CASH_SESSION = 'PURCHASES_COMMIT_INVALID_CASH_SESSION';
export const PURCHASES_SETTLEMENT_METHOD_UNAVAILABLE = 'PURCHASES_SETTLEMENT_METHOD_UNAVAILABLE';
export const PURCHASES_SETTLEMENT_REFERENCE_REQUIRED = 'PURCHASES_SETTLEMENT_REFERENCE_REQUIRED';
export const PURCHASES_SETTLEMENT_REFERENCE_UNAVAILABLE =
  'PURCHASES_SETTLEMENT_REFERENCE_UNAVAILABLE';
export const PURCHASES_SETTLEMENT_POLICY_INVALID = 'PURCHASES_SETTLEMENT_POLICY_INVALID';
export const PURCHASES_FOLIO_SEQUENCE_NOT_CONFIGURED = 'PURCHASES_FOLIO_SEQUENCE_NOT_CONFIGURED';
export const PURCHASES_FOLIO_SEQUENCE_INACTIVE = 'PURCHASES_FOLIO_SEQUENCE_INACTIVE';
export const PURCHASES_FOLIO_PREFIX_INVALID = 'PURCHASES_FOLIO_PREFIX_INVALID';
export const PURCHASES_FOLIO_PADDING_INVALID = 'PURCHASES_FOLIO_PADDING_INVALID';
export const PURCHASES_FOLIO_NEXT_NUMBER_INVALID = 'PURCHASES_FOLIO_NEXT_NUMBER_INVALID';
export const PURCHASES_FOLIO_NEXT_NUMBER_BELOW_ISSUED = 'PURCHASES_FOLIO_NEXT_NUMBER_BELOW_ISSUED';
export const PURCHASES_FOLIO_DUPLICATE_COLLISION = 'PURCHASES_FOLIO_DUPLICATE_COLLISION';
export const PURCHASES_FOLIO_SEQUENCE_VERSION_CONFLICT =
  'PURCHASES_FOLIO_SEQUENCE_VERSION_CONFLICT';
export const PURCHASES_FOLIO_SEQUENCE_BUSY = 'PURCHASES_FOLIO_SEQUENCE_BUSY';
export const PURCHASES_CANCEL_NOT_ALLOWED = 'PURCHASES_CANCEL_NOT_ALLOWED';
export const PURCHASES_CANCEL_REQUIRES_APPROVAL = 'PURCHASES_CANCEL_REQUIRES_APPROVAL';
export const PURCHASES_PRINT_FAILED = 'PURCHASES_PRINT_FAILED';
export const PURCHASES_SYNC_DUPLICATE_FOLIO = 'PURCHASES_SYNC_DUPLICATE_FOLIO';
export const PURCHASES_ADJUSTMENTS_NON_STACKING_VIOLATION =
  'PURCHASES_ADJUSTMENTS_NON_STACKING_VIOLATION';
export const PURCHASES_ADJUSTMENTS_INVALID_VALUE = 'PURCHASES_ADJUSTMENTS_INVALID_VALUE';
export const PURCHASES_ADJUSTMENTS_REASON_REQUIRED = 'PURCHASES_ADJUSTMENTS_REASON_REQUIRED';
export const PURCHASES_ADJUSTMENTS_NOT_SUPPORTED_FOR_PRESENTATION =
  'PURCHASES_ADJUSTMENTS_NOT_SUPPORTED_FOR_PRESENTATION';
export const PURCHASES_ADJUSTMENT_PRESET_NOT_FOUND = 'PURCHASES_ADJUSTMENT_PRESET_NOT_FOUND';
export const PURCHASES_ADJUSTMENT_PRESET_DISABLED = 'PURCHASES_ADJUSTMENT_PRESET_DISABLED';
export const PURCHASES_ADJUSTMENT_PRESET_NOT_ALLOWED = 'PURCHASES_ADJUSTMENT_PRESET_NOT_ALLOWED';
export const PURCHASES_MONETARY_SNAPSHOT_INVALID = 'PURCHASES_MONETARY_SNAPSHOT_INVALID';
export const PURCHASES_QUICK_VIEW_INVALID = 'PURCHASES_QUICK_VIEW_INVALID';
export const PURCHASES_QUICK_VIEW_PROTECTED = 'PURCHASES_QUICK_VIEW_PROTECTED';

export const purchasesErrorCodes = [
  PURCHASES_ID_REQUIRED,
  PURCHASES_ID_INVALID,
  PURCHASES_ID_OUT_OF_STATE_CAP_EXCEEDED,
  PURCHASES_LIMITS_EXCEEDED,
  PURCHASES_PIECES_MUST_BE_INTEGER,
  PURCHASES_DRAFT_NOT_FOUND,
  PURCHASES_DRAFT_ALREADY_ACTIVE,
  PURCHASES_LINES_NOT_FOUND,
  PURCHASES_MATERIAL_NOT_FOUND,
  PURCHASES_PRESENTATION_MISMATCH,
  PURCHASES_HELD_LOCKED,
  PURCHASES_HELD_LOCK_EXPIRED,
  PURCHASES_COMMIT_REQUIRES_CASH_SESSION,
  PURCHASES_COMMIT_AMBIGUOUS_CASH_SESSION,
  PURCHASES_COMMIT_INVALID_CASH_SESSION,
  PURCHASES_SETTLEMENT_METHOD_UNAVAILABLE,
  PURCHASES_SETTLEMENT_REFERENCE_REQUIRED,
  PURCHASES_SETTLEMENT_REFERENCE_UNAVAILABLE,
  PURCHASES_SETTLEMENT_POLICY_INVALID,
  PURCHASES_FOLIO_SEQUENCE_NOT_CONFIGURED,
  PURCHASES_FOLIO_SEQUENCE_INACTIVE,
  PURCHASES_FOLIO_PREFIX_INVALID,
  PURCHASES_FOLIO_PADDING_INVALID,
  PURCHASES_FOLIO_NEXT_NUMBER_INVALID,
  PURCHASES_FOLIO_NEXT_NUMBER_BELOW_ISSUED,
  PURCHASES_FOLIO_DUPLICATE_COLLISION,
  PURCHASES_FOLIO_SEQUENCE_VERSION_CONFLICT,
  PURCHASES_FOLIO_SEQUENCE_BUSY,
  PURCHASES_CANCEL_NOT_ALLOWED,
  PURCHASES_CANCEL_REQUIRES_APPROVAL,
  PURCHASES_PRINT_FAILED,
  PURCHASES_SYNC_DUPLICATE_FOLIO,
  PURCHASES_ADJUSTMENTS_NON_STACKING_VIOLATION,
  PURCHASES_ADJUSTMENTS_INVALID_VALUE,
  PURCHASES_ADJUSTMENTS_REASON_REQUIRED,
  PURCHASES_ADJUSTMENTS_NOT_SUPPORTED_FOR_PRESENTATION,
  PURCHASES_ADJUSTMENT_PRESET_NOT_FOUND,
  PURCHASES_ADJUSTMENT_PRESET_DISABLED,
  PURCHASES_ADJUSTMENT_PRESET_NOT_ALLOWED,
  PURCHASES_MONETARY_SNAPSHOT_INVALID,
  PURCHASES_QUICK_VIEW_INVALID,
  PURCHASES_QUICK_VIEW_PROTECTED,
] as const;

export type PurchasesErrorCode = (typeof purchasesErrorCodes)[number];
